/* src/app/dashboard/defence-popup/defence-popup.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.defense-dialog {
  width: 100%;
  height: 80%;
  flex-shrink: 0;
  border-radius: 4px;
  background: #FFF;
  padding-bottom: 10px;
}
.defense-dialog .dialog-header {
  background: #FFF !important;
  padding: 0em 1em;
}
.defense-dialog .dialog-header .close-icon {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  z-index: 99;
}
.defense-dialog .dialog-header .header {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  margin-top: 1em;
}
@media (min-width: 768px) {
  .defense-dialog .dialog-header .header {
    margin-left: 1.5em;
  }
}
.defense-dialog .dialog-header .header .separator {
  width: 100px;
  height: 4px;
  position: absolute;
  bottom: 9.678px;
  margin-left: 0.41em;
  background: #0A8080;
  margin: 0;
}
@media screen and (min-width: 48rem) {
  .defense-dialog .dialog-header .header .separator {
    bottom: 6px;
    left: 45px;
  }
}
.defense-dialog .dialog-header .header h1 {
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
}
.defense-dialog .dialog-header .header h2 {
  color: #000;
  font-family: "Roboto Flex", sans-serif;
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
}
.defense-dialog .dialog-header .header sup {
  top: -1.5em;
  color: #000;
  font-family: "Roboto Flex", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}
.defense-dialog .dialog-header .header .tm {
  color: #000;
  font-family: "Roboto Flex", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}
.defense-dialog .mat-mdc-dialog-content {
  padding-top: 0px;
}
.defense-dialog .mat-mdc-dialog-content .content-panel {
  margin-top: 1.5em;
  width: 100%;
  max-width: 700px;
  margin: 1.5em auto;
  height: 336px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background: var(--capital-gradent-top-component, linear-gradient(332deg, #DCE8E7 0%, #F3F3F3 100%));
}
@media screen and (min-width: 48rem) {
  .defense-dialog .mat-mdc-dialog-content .content-panel {
    width: 88%;
  }
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section {
  display: flex;
  flex-direction: column;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section .col-sm-6 {
  flex: 0 0 50%;
  max-width: 100%;
  flex-direction: row;
  justify-content: center;
  margin-top: 1em;
  margin-bottom: -2.5em;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section .sub-section .icon-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section .sub-section .icon-row .frame-icon {
  width: 281.484px;
  height: 100px;
  margin-top: 3em;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section .sub-section .description h5 {
  display: flex;
  color: #000;
  font-family: "Roboto Flex", sans-serif;
  font-size: 20px;
  font-weight: 400;
  margin: 90px 10px 0px 10px;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-block {
  position: relative;
  width: 100%;
  flex-shrink: 0;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-block .background-blur {
  width: 100%;
  height: 336px;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-block .play-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  color: white;
  font-size: 16px;
  padding: 12px 24px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  text-align: center;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section.monthlyTier {
  display: flex;
  flex-direction: row;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-panel {
  margin-left: 1.5em;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-panel .add-icon {
  display: flex;
  width: 37px;
  height: 132px;
  flex-direction: column;
  justify-content: center;
  color: #000;
  font-size: 30px;
  font-size: 31px;
  font-weight: 700;
  line-height: normal;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-panel .sub-section .icon-row {
  margin-left: 4em;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-panel .sub-section .icon-row .frame-icon {
  margin-bottom: 1em;
  margin-top: 1.5em;
  margin-left: -2em;
  width: 200px;
  height: 72.367px;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-panel .sub-section .icon-row .ups-icon {
  width: 52.026px;
  height: 55px;
  margin-bottom: 1em;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-panel .sub-section .description {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: 7px;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-panel .sub-section .description .tm {
  color: #595555;
  font-family: "Roboto Flex", sans-serif;
  font-size: 8px;
  font-style: normal;
  font-weight: 700;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-panel .sub-section .description .rated {
  position: relative;
  top: -23px;
  margin-left: 129px;
  font-size: 10px;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-panel .sub-section .description h1 {
  width: 148.078px;
  height: 18.005px;
  right: -5.227px;
  top: 0.189px;
  color: #595555;
  font-family: "Roboto Flex", sans-serif;
  font-size: 20.328px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-panel .sub-section .description h4 {
  width: 161.771px;
  height: 13.358px;
  flex-shrink: 0;
  color: #595555;
  text-align: center;
  font-family: "Roboto Flex", sans-serif;
  font-size: 13.939px;
  font-style: normal;
  font-weight: 500;
  line-height: 0px;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-panel .sub-section .description h3 {
  display: flex;
  width: 155.1px;
  height: 6.1px;
  flex-direction: column;
  justify-content: center;
  color: var(--ups-brand-colors-ups-brown, #300);
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  font-family: Inter;
  margin-top: -5px;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-panel .sub-section .description h5 {
  display: flex;
  width: 155.1px;
  height: 34.1px;
  flex-direction: column;
  justify-content: center;
  color: var(--ups-brand-colors-ups-brown, #300);
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  font-family: Inter;
  margin-top: -5px;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-panel .label {
  display: flex;
  width: 100%;
  height: 44px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 3em;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-panel .label h1 {
  color: #000;
  text-align: center;
  font-size: 23px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  font-family: "Roboto Flex", sans-serif;
}
.defense-dialog .mat-mdc-dialog-content .content-panel .section-panel .label h2 {
  font-weight: 700;
  margin-right: 18px;
  font-size: 33px;
  display: flex;
  justify-content: center;
  color: #000;
  font-size: 30px;
  font-size: 31px;
  font-weight: 700;
  line-height: normal;
}
.defense-dialog .mat-mdc-dialog-content .action-panel {
  margin: auto;
  display: flex;
  width: 219.6px;
  height: 29.8px;
  align-items: center;
  justify-content: center;
}
.defense-dialog .mat-mdc-dialog-content .action-panel .indicator-panel {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: -1.9em;
}
.defense-dialog .mat-mdc-dialog-content .action-panel .indicator-panel .action-icons {
  width: 15.6px;
  height: 15.6px;
  fill: #FFF;
  stroke-width: 2.4px;
  stroke: #8C8585;
}
.defense-dialog .mat-mdc-dialog-content .action-panel .indicator-panel .action-icons:hover {
  cursor: pointer;
}
.defense-dialog .mat-mdc-dialog-content .action-panel .indicator-panel .margin-top-3px {
  margin-top: 3px;
}
.defense-dialog .mat-mdc-dialog-content .action-panel .chevron_left-icon {
  display: flex;
  margin-right: 28px;
  justify-content: center;
  align-items: center;
  margin-top: -1.3em;
}
.defense-dialog .mat-mdc-dialog-content .action-panel .chevron_right-icon {
  display: flex;
  margin-left: 28px;
  justify-content: center;
  align-items: center;
  margin-top: -1.3em;
}
.defense-dialog .mat-mdc-dialog-content .action-panel .chevron_left-icon:hover,
.defense-dialog .mat-mdc-dialog-content .action-panel .chevron_right-icon:hover {
  cursor: pointer;
}
.defense-dialog .mat-mdc-dialog-content .action-btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  word-wrap: break-word;
  flex-direction: column;
  align-items: stretch;
  max-width: 700px;
  margin: 12px auto;
  column-gap: 42px;
  row-gap: 15px;
}
@media screen and (min-width: 48rem) {
  .defense-dialog .mat-mdc-dialog-content .action-btn {
    flex-direction: row;
    width: 88%;
  }
}
.defense-dialog .mat-mdc-dialog-content .action-btn button,
.defense-dialog .mat-mdc-dialog-content .action-btn .mat-mdc-button {
  display: flex;
  width: 100%;
  height: auto;
  padding: 0 1.25rem;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--ups-brand-colors-ups-teal, #0A8080);
  border-radius: 4px;
  font-family: "Roboto Flex", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  font-feature-settings: "clig" off, "liga" off;
}
@media screen and (min-width: 48rem) {
  .defense-dialog .mat-mdc-dialog-content .action-btn button,
  .defense-dialog .mat-mdc-dialog-content .action-btn .mat-mdc-button {
    width: 305px;
    height: 50px;
    padding: 10px 24px;
  }
}
.defense-dialog .mat-mdc-dialog-content .action-btn .complementary-btn {
  float: left;
  background: var(--ups-brand-colors-ups-teal, #0A8080);
  color: var(--ups-brand-colors-ups-white, #FFF);
}
@media screen and (min-width: 48rem) {
  .defense-dialog .mat-mdc-dialog-content .action-btn .complementary-btn {
    padding: 10px 16px;
  }
}
.defense-dialog .mat-mdc-dialog-content .action-btn .learn-more-btn {
  float: right;
  background: var(--ups-brand-colors-ups-white, #FFF);
  color: var(--ups-brand-colors-ups-teal, #0A8080);
}
.defense-dialog .dd-formula {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.defense-dialog .dd-formula .operator-styling {
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.defense-dialog .dd-formula .sum {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 20px;
}
@media screen and (min-width: 32.6rem) {
  .defense-dialog .dd-formula .sum {
    flex-direction: row;
    justify-content: space-around;
    margin-top: 74px;
    padding: 0 60px;
  }
}
.defense-dialog .dd-formula .sum .image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.defense-dialog .dd-formula .sum .image-container p {
  color: var(--ups-brand-colors-ups-brown, #300);
  text-align: center;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (min-width: 32.6rem) {
  .defense-dialog .dd-formula .sum .image-container {
    width: 40%;
  }
}
.defense-dialog .dd-formula .result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.defense-dialog .dd-formula .result p {
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 23px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 41px;
}
.defense-dialog .row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  text-align: center;
  justify-content: center;
}
/*# sourceMappingURL=defence-popup.component.css.map */
